import script from "./BaseDrugInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDrugInfo.vue?vue&type=script&setup=true&lang=js"

import "./BaseDrugInfo.vue?vue&type=style&index=0&id=2843e7ce&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2843e7ce"]])

export default __exports__